import { render } from "./LandingServicios.vue?vue&type=template&id=caaaa6cc&scoped=true"
import script from "./LandingServicios.vue?vue&type=script&lang=js"
export * from "./LandingServicios.vue?vue&type=script&lang=js"

import "./LandingServicios.vue?vue&type=style&index=0&id=caaaa6cc&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caaaa6cc"]])

export default __exports__